import { styled } from '@mui/material/styles'
import { Slider } from '@mui/material'

const StyledSlider = styled(Slider)(({ theme }) => ({
  marginLeft: 10,
  maxWidth: 'calc(100% - 18px)',
  height: '18px',
  padding: 0,
  '@media (pointer: coarse)': {
    /** mobile view */
    padding: 0,
  },

  '& .MuiSlider-track': {
    border: 'none',
    height: '18px',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 'calc(100% + 18px)',
      height: '18px',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.primary.main,
      transform: 'translateX(-9px)',
    },
  },
  '& .MuiSlider-rail': {
    height: '18px',
    border: 'none',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.shades.shade03,
    boxShadow: 'none',
    transform: 'scaleX(1.03)',
    top: 'initial',
  },
  '& .MuiSlider-thumb': {
    backgroundColor: theme.palette.grey.shadowLight,
    height: 14,
    width: 14,
    '&:before': {
      boxShadow: 'none',
    },
  },
  '& .MuiSlider-mark': {
    height: 18,
    color: theme.palette.grey.grey03,
    top: 9,
    width: 3,
    borderRadius: 0,
  },
  '& .MuiSlider-marked': {
    height: 18,
    color: theme.palette.primary.light,
    top: 9,
    width: 3,
    borderRadius: 0,
  },
}))

export default StyledSlider
